import { render, staticRenderFns } from "./soccer-icon.vue?vue&type=template&id=21d1f2f8"
import script from "./soccer-icon.vue?vue&type=script&lang=js"
export * from "./soccer-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports